import swal from "sweetalert";

export default {
  success(msg) {
    swal({
      text: msg,
      icon: "success",
    });
  },

  fail(msg) {
    swal({
      text: msg,
      icon: "error",
    });
  },

  info(msg) {
    swal({
      text: msg,
      icon: "info",
    });
  },
};
